export default () => ({
  root: {
    height: '100%',
    position: 'relative',
  },
})
